module.exports = __webpack_public_path__ + "img/portraits_13_V.2a239089.webp";